import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Grid, GridItem, Image as ChakraImage, Text } from '@chakra-ui/react';
import { FT_PI_BB_CCUI_HDP_IMAGE_GALLERY_REDESIGN } from '@whitbread-eos/api';
import { Button, Carousel, Icon, MobileCarousel, ModalVariants } from '@whitbread-eos/atoms';
import { formatAssetsUrl, akamaiImageLoader, isIVMEnabled, useSemanticTypography, useFeatureToggle, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useState } from 'react';
import ImageGalleryModal from '../ImageGalleryModal/ImageGalleryModal.component';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function HotelGallery(_ref) {
  var thumbnailSectionHeight = _ref.thumbnailSectionHeight,
    isLessThanLg = _ref.isLessThanLg,
    eagerLoad = _ref.eagerLoad;
  var _useStaticHotelInform = useStaticHotelInformation(),
    data = _useStaticHotelInform.galleryImages,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error,
    hotelFlags = _useStaticHotelInform.hotelFlags;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeThumbnail = _useState2[0],
    setActiveThumbnail = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isModalVisible = _useState4[0],
    setIsModalVisible = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    activeSlide = _useState6[0],
    setActiveSlide = _useState6[1];
  var getTypographyProps = useSemanticTypography();
  var imageLoader = isIVMEnabled() ? akamaiImageLoader : undefined;
  var _useFeatureToggle = useFeatureToggle(),
    _useFeatureToggle$FT_ = _useFeatureToggle[FT_PI_BB_CCUI_HDP_IMAGE_GALLERY_REDESIGN],
    isImageGalleryRedesignEnabled = _useFeatureToggle$FT_ === void 0 ? false : _useFeatureToggle$FT_;
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!data) {
    return null;
  }
  return _jsxs(_Fragment, {
    children: [isLessThanLg ? renderSingleThumbnail() : renderThumbnailsGrid(), isImageGalleryRedesignEnabled ? renderImageGalleryModal() : renderModal()]
  });
  function renderSingleThumbnail() {
    var singleThumbnailStyles = {
      position: 'relative',
      padding: '0 !important',
      marginLeft: {
        mobile: '-1.9rem !important'
      },
      width: {
        mobile: 'calc(100% + var(--chakra-space-3xl))',
        md: 'calc(100% + var(--chakra-space-4xl))'
      },
      h: {
        sm: '22.356rem',
        xs: '18.938rem',
        mobile: '11.25rem',
        base: '11.25rem'
      },
      mb: 'lg',
      cursor: 'pointer'
    };
    if (!(data !== null && data !== void 0 && data.length)) {
      return null;
    }
    return _jsxs(Box, {
      position: "relative",
      "data-testid": "singleThumbnail",
      onClick: () => setIsModalVisible(isImageGalleryRedesignEnabled),
      children: [_jsxs(Box, _objectSpread(_objectSpread({}, singleThumbnailStyles), {}, {
        children: [_jsx(Carousel, {
          activeSlide: activeSlide,
          setActiveSlide: setActiveSlide,
          children: renderImages()
        }, activeThumbnail), activeSlide === 0 && renderFlagOverlay()]
      })), renderImagesCountBadge(), renderOverlayImageCaption()]
    });
  }
  function renderFlagOverlay() {
    if (!(hotelFlags !== null && hotelFlags !== void 0 && hotelFlags.isEnabled) || !(hotelFlags !== null && hotelFlags !== void 0 && hotelFlags.flagOverlay)) {
      return null;
    }
    var _hotelFlags$flagOverl = hotelFlags.flagOverlay,
      backgroundColour = _hotelFlags$flagOverl.backgroundColour,
      textColour = _hotelFlags$flagOverl.textColour,
      text = _hotelFlags$flagOverl.text,
      backgroundImage = _hotelFlags$flagOverl.backgroundImage;
    var overlayContainerStyles = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none'
    };
    var overlayImageStyles = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'scale-down',
      objectPosition: 'top left',
      paddingLeft: 'var(--chakra-space-md)'
    };
    var overlayTextStyles = {
      position: 'absolute',
      bottom: 'sm',
      left: 'sm',
      fontFamily: 'Sunset-Sans, helvetica, arial, sans-serif',
      fontWeight: 'black',
      fontSize: {
        base: '4xl',
        sm: '6xl'
      },
      lineHeight: {
        base: '5',
        sm: '6'
      },
      letterSpacing: '-0.02em',
      pl: {
        mobile: 'var(--chakra-space-md)'
      }
    };
    return _jsxs(Box, _objectSpread(_objectSpread({}, overlayContainerStyles), {}, {
      backgroundColor: backgroundColour !== null && backgroundColour !== void 0 ? backgroundColour : undefined,
      children: [backgroundImage && _jsx(ChakraImage, {
        src: formatAssetsUrl(backgroundImage),
        alt: "overlay",
        style: overlayImageStyles
      }), _jsx(Text, _objectSpread(_objectSpread({}, overlayTextStyles), {}, {
        color: textColour !== null && textColour !== void 0 ? textColour : undefined,
        children: text
      }))]
    }));
  }
  function renderImagesCountBadge() {
    var imagesCountBadgeStyles = {
      display: 'inline',
      color: 'baseWhite',
      fontSize: 'xs',
      lineHeight: 'md',
      position: 'absolute',
      bottom: 'md',
      right: 0,
      bg: 'rgba(51, 51, 51, 0.75)',
      px: 'sm',
      borderRadius: 4
    };
    return _jsxs(Box, _objectSpread(_objectSpread({}, imagesCountBadgeStyles), {}, {
      "data-testid": "hdp_hotelGalleryImagesCount",
      children: [activeSlide + 1, " / ", data === null || data === void 0 ? void 0 : data.length]
    }));
  }
  function renderOverlayImageCaption() {
    var iconStyles = {
      mr: 'sm',
      height: '1rem'
    };
    var imageCaptionStyles = {
      position: 'absolute',
      bottom: 'md',
      left: 0,
      bg: 'rgba(255, 255, 255, 0.75)',
      px: 'sm',
      borderRadius: 4,
      alignItems: 'center',
      maxWidth: '75%'
    };
    var imageCaptionTextStyles = {
      fontSize: 'xs',
      lineHeight: 'md',
      color: 'darkGrey1'
    };
    var item = data === null || data === void 0 ? void 0 : data[activeSlide];
    if (!item) {
      return null;
    }
    return _jsxs(Flex, _objectSpread(_objectSpread({}, imageCaptionStyles), {}, {
      "data-testid": "carousel_hotel-image-caption",
      children: [item.iconSrc && _jsx(Icon, _objectSpread({
        src: formatAssetsUrl(item.iconSrc)
      }, iconStyles)), _jsx(Text, _objectSpread(_objectSpread({}, imageCaptionTextStyles), {}, {
        children: item.caption
      }))]
    }));
  }
  function renderThumbnailsGrid() {
    var _data$map;
    var thumbnailGridStyles = {
      templateRows: 'repeat(2, 1fr)',
      templateColumns: 'repeat(4, 1fr)',
      gap: 3,
      w: '100%'
    };
    var firstThreeThumbnails = (data === null || data === void 0 || (_data$map = data.map((item, index) => {
      var _item$thumbnailSrc, _item$alt;
      var sizes = index === 0 ? '(max-width: 1280px) 480px, (min-width: 1281px) 514px' : '164px';
      return _jsx(Thumbnail, {
        src: formatAssetsUrl((_item$thumbnailSrc = item === null || item === void 0 ? void 0 : item.thumbnailSrc) !== null && _item$thumbnailSrc !== void 0 ? _item$thumbnailSrc : ''),
        alt: (_item$alt = item === null || item === void 0 ? void 0 : item.alt) !== null && _item$alt !== void 0 ? _item$alt : '',
        onClick: () => {
          setActiveThumbnail(index);
          setIsModalVisible(true);
          setActiveSlide(index);
        },
        imageLoader: imageLoader,
        loadWithPriority: eagerLoad ? true : index === 0,
        sizes: sizes
      }, item.alt);
    })) === null || _data$map === void 0 ? void 0 : _data$map.slice(0, 3)) || [];
    return _jsxs(Box, {
      position: "relative",
      "data-testid": "thumbnails",
      children: [_jsxs(Grid, _objectSpread(_objectSpread({}, thumbnailGridStyles), {}, {
        h: thumbnailSectionHeight,
        children: [_jsxs(GridItem, {
          rowSpan: 2,
          colSpan: 3,
          position: "relative",
          children: [firstThreeThumbnails[0] || _jsx(EmptyThumbnail, {}), renderFlagOverlay()]
        }), _jsx(GridItem, {
          colSpan: 1,
          children: firstThreeThumbnails[1] || _jsx(EmptyThumbnail, {})
        }), _jsx(GridItem, {
          colSpan: 1,
          children: firstThreeThumbnails[2] || _jsx(EmptyThumbnail, {})
        })]
      })), data && (data === null || data === void 0 ? void 0 : data.length) > 3 && renderSeeAllPhotosButton()]
    });
  }
  function renderSeeAllPhotosButton() {
    var seeAllPhotosButtonStyles = {
      position: 'absolute',
      bottom: 'sm',
      right: 'sm',
      width: 'auto',
      height: 'var(--chakra-space-xl)',
      fontSize: 'sm'
    };
    return _jsx(Button, _objectSpread(_objectSpread({
      variant: "tertiary",
      size: "sm",
      "data-testid": "hdp_hotelGallerySeeAllPhotos"
    }, seeAllPhotosButtonStyles), {}, {
      onClick: () => {
        setActiveThumbnail(0);
        setIsModalVisible(true);
        setActiveSlide(0);
      },
      children: _jsx(Text, _objectSpread(_objectSpread({
        as: "span"
      }, getTypographyProps({}, seeAllPhotosSemanticTypography)), {}, {
        children: t('hoteldetails.seeallphotos')
      }))
    }));
  }
  function renderModal() {
    var _renderImages;
    var mobileGalleryThumbnails = data === null || data === void 0 ? void 0 : data.map(item => {
      var _item$thumbnailSrc2, _item$alt2;
      return _jsx(ChakraImage, {
        src: formatAssetsUrl((_item$thumbnailSrc2 = item === null || item === void 0 ? void 0 : item.thumbnailSrc) !== null && _item$thumbnailSrc2 !== void 0 ? _item$thumbnailSrc2 : ''),
        alt: (_item$alt2 = item === null || item === void 0 ? void 0 : item.alt) !== null && _item$alt2 !== void 0 ? _item$alt2 : ''
      }, item.alt);
    });
    return _jsx(ModalVariants, {
      isOpen: isModalVisible,
      onClose: () => {
        setIsModalVisible(false);
        setActiveThumbnail(0);
        setActiveSlide(0);
      },
      dataTestId: "hdp_hotelGallery",
      variant: "gallery",
      variantProps: {
        title: "".concat(activeSlide + 1, "/").concat((_renderImages = renderImages()) === null || _renderImages === void 0 ? void 0 : _renderImages.length)
      },
      children: isLessThanLg ? _jsx(MobileCarousel, {
        activeSlide: activeSlide,
        setActiveSlide: setActiveSlide,
        thumbnails: mobileGalleryThumbnails,
        children: renderImages()
      }, activeThumbnail) : _jsx(Box, {
        w: "41.775rem",
        px: "lg",
        children: _jsx(Carousel, {
          activeSlide: activeSlide,
          setActiveSlide: setActiveSlide,
          children: renderImages()
        }, activeThumbnail)
      })
    });
  }
  function renderImageGalleryModal() {
    return _jsx(ImageGalleryModal, {
      isModalOpen: isModalVisible,
      onModalClose: () => setIsModalVisible(false)
    });
  }
  function renderImages() {
    var iconStyles = {
      mr: 'sm'
    };
    var captionFlexStyles = {
      position: 'relative',
      alignItems: 'center',
      justify: 'center',
      minH: '2rem'
    };
    var sizes;
    if (!isLessThanLg) {
      sizes = '620px';
    }
    return data === null || data === void 0 ? void 0 : data.map(item => {
      var _item$imageSrc;
      return _jsxs(Box, {
        children: [_jsx(Box, {
          position: "relative",
          w: "full",
          h: {
            sm: '22.356rem',
            xs: '18.938rem',
            mobile: '11.25rem',
            base: '11.25rem'
          },
          children: _jsx(Image, {
            src: formatAssetsUrl((_item$imageSrc = item === null || item === void 0 ? void 0 : item.imageSrc) !== null && _item$imageSrc !== void 0 ? _item$imageSrc : ''),
            alt: "Hotel Image",
            fill: true,
            style: {
              objectFit: 'cover'
            },
            priority: false,
            loader: imageLoader,
            sizes: sizes
          })
        }), !isLessThanLg && _jsxs(Flex, _objectSpread(_objectSpread({}, captionFlexStyles), {}, {
          "data-testid": "carousel_hotel-image-caption",
          children: [item.iconSrc && _jsx(Icon, _objectSpread({
            src: formatAssetsUrl(item.iconSrc)
          }, iconStyles)), _jsx(Text, {
            children: item.caption
          })]
        }))]
      }, item.alt);
    });
  }
}
var seeAllPhotosSemanticTypography = {
  textStyle: 'link-s-emphasis'
};
function Thumbnail(_ref2) {
  var src = _ref2.src,
    alt = _ref2.alt,
    onClick = _ref2.onClick,
    loadWithPriority = _ref2.loadWithPriority,
    imageLoader = _ref2.imageLoader,
    _ref2$sizes = _ref2.sizes,
    sizes = _ref2$sizes === void 0 ? '' : _ref2$sizes;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isHovering = _useState8[0],
    setIsHovering = _useState8[1];
  var thumbnailStyes = {
    width: '100%',
    height: '100%',
    position: 'relative',
    cursor: 'pointer'
  };
  return _jsx(Box, _objectSpread(_objectSpread({}, thumbnailStyes), {}, {
    onMouseEnter: () => setIsHovering(true),
    onMouseLeave: () => setIsHovering(false),
    sx: {
      '& img': {
        transition: 'filter 0.3s ease-in-out',
        '&.darken': {
          filter: 'brightness(90%)'
        }
      }
    },
    children: _jsx(Image, {
      src: src,
      alt: alt,
      fill: true,
      style: {
        objectFit: 'cover'
      },
      onClick: onClick,
      className: isHovering ? 'darken' : '',
      priority: loadWithPriority,
      loader: imageLoader,
      sizes: sizes
    })
  }));
}
function EmptyThumbnail() {
  return _jsx(Box, {
    "data-testid": "emptyThumbnail",
    bgColor: "lightGrey4",
    h: "100%",
    w: "100%"
  });
}